import { getCustomClientIds as e } from "./generate-client-options.js";
import { getSnippet as t } from "./get-snippet.js";
import { operationToHar as n } from "./operation-to-har/operation-to-har.js";
import { getResolvedRef as r } from "@scalar/workspace-store/helpers/get-resolved-ref";
//#region src/code-example/helpers/generate-code-snippet.ts
var i = ({ clientId: i, customCodeSamples: a, includeDefaultHeaders: o = !1, operation: s, method: c, path: l, example: u, contentType: d, server: f, securitySchemes: p, globalCookies: m, openapiVersion: h, requestBodyCompositionSelection: g, defaultDisabledParameters: _ }) => {
	try {
		if (!i) return "";
		if (i.startsWith("custom")) {
			let t = e(a), n = a.filter((e, n) => t[n] === i);
			if (!n.some((e) => e.example !== void 0)) return n[0]?.source ?? "Custom example not found";
			let o = r(s.requestBody)?.content ?? {}, c = d ?? Object.keys(o)[0], l = u ?? Object.keys(o[c ?? ""]?.examples ?? {})[0];
			return (n.find((e) => e.example === l && e.contentType === c) ?? n.find((e) => e.example === l && e.contentType === void 0))?.source ?? null;
		}
		let v = n({
			operation: s,
			contentType: d,
			method: c,
			path: l,
			server: f,
			securitySchemes: p,
			example: u,
			globalCookies: m,
			includeDefaultHeaders: o,
			openapiVersion: h,
			requestBodyCompositionSelection: g,
			defaultDisabledParameters: _
		}), [y, b] = i.split("/"), [x, S] = t(y, b, v);
		return x ? (console.error("[generateCodeSnippet]", x), x.message ?? "Error generating code snippet") : S;
	} catch (e) {
		return console.error("[generateCodeSnippet]", e), "Error generating code snippet";
	}
};
//#endregion
export { i as generateCodeSnippet };

//# sourceMappingURL=generate-code-snippet.js.map